import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ingest-progress-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ingest-progress-modal.html',
  styleUrl: './ingest-progress-modal.css'
})
export class IngestProgressModal {
  percent = input(0);
  close = output<void>();

  onClose() {
    this.close.emit();
  }
}
